import http from "@/utils/http";
import httpApi from "@/apis/httpApi";

export const getRuleManageList = ({
    current,
    size
}) => {
    return http.get({
        url: httpApi.securityCenter.getRuleManageList,
        data: {
            current,
            size
        }
    });
};
export const addRuleShare = ({
    ruleId
}) => {
    return http.get({
        url: httpApi.securityCenter.addRuleShare,
        data: {
            ruleId
        }
    })
}
export const ruleShareList = (data) => {
    return http.post({
        url: httpApi.securityCenter.ruleShareList,
        data
    })
}
export const createClient = () => {
    return http.get({
        url: httpApi.securityCenter.createClient
    })
}
export const checkClient = () => {
    return http.get({
        url: httpApi.securityCenter.checkClient
    })
}

export const getRuleShare = (data) => {
    return http.get({
        url: httpApi.securityCenter.getRuleShare,
        data
    })
}

export const updateRuleShare = ({
    id
}) => {
    return http.get({
        url: httpApi.securityCenter.updateRuleShare,
        data: {
            id
        }
    })
}
export const getLogPageById = ({
    id,
    ruleId,
    ruleVersion,
    checkType,
    shareTime,
    checkTime,
    current,
    size
}) => {
    return http.post({
        url: httpApi.securityCenter.getLogPageById,
        data: {
            id,
            ruleId,
            ruleVersion,
            checkType,
            shareTime,
            checkTime,
            current,
            size
        }
    })
}
export const editRule = ({
    id,
    ruleName,
    ruleIntroduction,
    ruleContent,
    isShare,
    fitOs
}) => {
    return http.post({
        url: httpApi.securityCenter.editRule,
        data: {
            id,
            ruleName,
            ruleIntroduction,
            ruleContent,
            isShare,
            fitOs
        }
    });
};

export const getRuleText = ({
    id
}) => {
    return http.post({
        url: httpApi.securityCenter.getRuleText,
        data: {
            id
        }
    });
};
export const delRule = ({
    id
}) => {
    return http.post({
        url: httpApi.securityCenter.delRule,
        data: {
            id
        }
    });
};

export const enabledRule = ({
    id,
    type
}) => {
    return http.post({
        url: httpApi.securityCenter.enabledRule,
        data: {
            id,
            type
        }
    });
};

export const importFile = ({
    file
}) => {
    return http.post({
        url: httpApi.securityCenter.importFile,
        data: {
            file
        }
    });
};

export const applySecurityGroup = ({
    id,
    securityGroupId
}) => {
    return http.post({
        url: httpApi.securityCenter.applySecurityGroup,
        data: {
            id,
            securityGroupId
        }
    });
};

export const listSelectLabel = () => {
    return http.post({
        url: httpApi.securityCenter.listSelectLabel
    });
};
export const getSecurityGroupList = () => {
    return http.post({
        url: httpApi.securityCenter.getSecurityGroupList
    });
};

export const listSoftType = ({
    parentId
}) => {
    return http.post({
        url: httpApi.securityCenter.listSoftType,
        data: {
            parentId
        }
    });
};

export const getBarList = ({
    search,
    current,
    size,
    parentId,
    value
}) => {
    return http.get({
        url: httpApi.securityCenter.getBarList,
        data: {
            search,
            current,
            size,
            parentId,
            value
        }
    });
};

export const protectionOpenOrClose = ({
    barId,
    protectionStatus
}) => {
    return http.post({
        url: httpApi.securityCenter.protectionOpenOrClose,
        data: {
            barId,
            protectionStatus
        }
    });
};

export const moveSecurityGroup = ({
    barId,
    securityGroupId
}) => {
    return http.post({
        url: httpApi.securityCenter.moveSecurityGroup,
        data: {
            barId,
            securityGroupId
        }
    });
};

export const environmentSettings = ({
    barId,
    arr
}) => {
    return http.post({
        url: httpApi.securityCenter.environmentSettings,
        data: {
            barId,
            arr
        }
    });
};
export const listEvnInfo = ({
    barId
}) => {
    return http.post({
        url: httpApi.securityCenter.listEvnInfo,
        data: {
            barId
        }
    });
};

export const editSecurityGroup = (data) => {
    return http.post({
        url: httpApi.securityCenter.editSecurityGroup,
        data: data
    });
};
export const delSecurityGroup = ({
    id
}) => {
    return http.post({
        url: httpApi.securityCenter.delSecurityGroup,
        data: {
            id
        }
    });
};

export const payOrder = ({
    orderNo
}) => {
    return http.post({
        url: httpApi.securityCenter.payOrder,
        data: {
            orderNo
        }
    });
};

export const getGroupList = (data) => {
  return http.post({
      url: httpApi.debugModel.getGroupList,
      data
  })
}


export const applyRule2SecurityGroup = ({
  ruleIds,
  securityGroupId
}) => {
  return http.get({
      url: httpApi.securityCenter.applyRule2SecurityGroup,
      data: {
         ruleIds,
         securityGroupId
      }
  });
};